var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.092 1.34886H12.2208C12.1061 0.585393 11.4474 0 10.652 0H7.35217C6.55674 0 5.89804 0.585393 5.78339 1.34886H1.91016C1.35787 1.34886 0.910156 1.79658 0.910156 2.34886V13.8337C0.910156 14.386 1.35787 14.8337 1.91016 14.8337H16.092C16.6443 14.8337 17.092 14.386 17.092 13.8337V2.34886C17.092 1.79658 16.6443 1.34886 16.092 1.34886ZM9.00053 12.1365C11.2348 12.1365 13.046 10.3253 13.046 8.09109C13.046 5.85685 11.2348 4.04564 9.00053 4.04564C6.76629 4.04564 4.95508 5.85685 4.95508 8.09109C4.95508 10.3253 6.76629 12.1365 9.00053 12.1365ZM9.00166 10.7882C10.4912 10.7882 11.6986 9.58075 11.6986 8.09126C11.6986 6.60176 10.4912 5.39429 9.00166 5.39429C7.51216 5.39429 6.30469 6.60176 6.30469 8.09126C6.30469 9.58075 7.51216 10.7882 9.00166 10.7882Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.b29de6d5ec0ecb4dfb342c6239c69f39.svg";
export { ForwardRef as ReactComponent };